/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon16Solid = forwardRef('ArrowDUturnLeftUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M.41 5.753a1.125 1.125 0 0 0 1.68 1.495l2.035-2.289V8.75a5.875 5.875 0 0 0 11.75 0v-4.5a1.125 1.125 0 0 0-2.25 0v4.5a3.625 3.625 0 0 1-7.25 0V4.96l2.034 2.288a1.125 1.125 0 1 0 1.682-1.495l-3.253-3.66a2.125 2.125 0 0 0-3.176 0L.409 5.754Z" })));
});
